// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I9fr","col":"styles_col__1A2cp"};